import axios from 'axios'
import omitBy from 'lodash/omitBy'
import pick from 'lodash/pick'
import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'
import querystring from 'querystring'
import appendQuery from 'append-query'
import RequestError from './RequestError'
import ErrorCodeHandler from './ErrorCodeHandler'
import { merge } from '../utils/commonUtils'

const CALLBACK = 'handleCallback'
const DEFAULT_FETCH_CONFIG = {
  /*
   * Base on current design (jsonp solution),
   * force to use this header
   */
  headers: {
    Accept: 'text/html',
    'Content-type': 'application/x-www-form-urlencoded',
  },
  /*
   * Base on current design (jsonp solution),
   * force to use this data config
   */
  data: {
    request_type: 'JSONP',
    featureResponseType: 'JSONP',
    callback: CALLBACK,
  },

  withCredentials: true,
}

const callbackRemover = (() => {
  const reg = new RegExp(`^${CALLBACK}\\(|\\);$`, 'g')
  return str => {
    const result = str.replace(reg, '')
    return result ? result.replace(/^'|'$/g, '') : undefined
  }
})()

const ajax = (method, path, fetchConfig) => {
  let url = path
  const _fetchConfig = merge({ method }, DEFAULT_FETCH_CONFIG, fetchConfig)
  let { data } = _fetchConfig
  const { _ignoreTrim } = _fetchConfig
  data = omitBy(data, isNil)
  !_ignoreTrim && Object.keys(data).forEach(k => {
    if (data[k] && data[k].trim) {
      data[k] = data[k].trim()
    }
  })

  if (method === 'get' || method === 'delete') {
    /** FireFox ajax get request can not have a data, so let it be `null`  */
    _fetchConfig.data = undefined
    url = appendQuery(path, { ...data, _: new Date().getTime() })
  } else if (method !== 'delete') {
    if (data.postResource === 'wallet') {
      if (isEmpty(data.allowedParams)) {
        _fetchConfig.data = JSON.stringify(data)
      } else {
        const filterData = pick(data, data.allowedParams)
        _fetchConfig.data = JSON.stringify(filterData)
      }
    } else {
      _fetchConfig.data = querystring.stringify(data)
    }
  }

  function handleFullFil(resolve, reject, response) {
    const { status } = response
    let resp
    let parseError
    let jsonResp
    if (typeof response.data === 'string') {
      resp = callbackRemover(response.data)
      if (resp) {
        try {
          jsonResp = JSON.parse(resp)
        } catch (e) {
          parseError = new RequestError('FAILED')
        }
      }
    } else {
      // typeof data is 'object'
      resp = response.data
      jsonResp = response.data
    }

    const statusCode = parseInt(status / 100, 10)
    if (statusCode === 2 || statusCode === 3) {
      resolve(jsonResp || resp || {})
    } else {
      reject(parseError || new RequestError(status))
    }
  }

  function handleReject(reject, error) {
    const errMsg = ErrorCodeHandler.handleGeneral(error && error.response && error.response.data)
    reject(new RequestError('FAILED', errMsg))
  }

  // eslint-disable-next-line no-promise-executor-return
  return new Promise((resolve, reject) => axios({
    url,
    ..._fetchConfig,
  }).then(
    handleFullFil.bind(null, resolve, reject),
    handleReject.bind(null, reject),
  ))
}

export default ['get', 'post', 'put', 'patch', 'delete', 'head'].reduce(
  (api, method) => ({
    ...api,
    [method]: ajax.bind(null, method),
  }),
  {},
)
